export default __webpack_public_path__ + "static/media/bunitcreate.5b8daf0b.svg";